import { Box, Button, CloudinaryImage, ResponsiveSection, Text } from '@stitch-fix/mode-react';
import { useViewEvent, useSelectEvent } from '@stitch-fix/event-reporter';
import styles from './styles.module.scss';
const PAGE_FOOTER = {
  headline: ["Let's get to know each other"],
  description: 'Our stylists can help complete a specific look, collaborate on trends, recommend pieces that fit your unique body and so much more.',
  cta: {
    text: 'Get started',
    destinationPath: '/signup'
  },
  image: {
    altText: 'Stylists ready to personalize your shopping experience',
    baseUrl: 'https://res.cloudinary.com/stitch-fix/image/upload',
    mediaPath: '/v1721172154/landing-pages/pages/US/BRND-FY24-WEB-Rebrand%20Client%20Experience%20Audit-1207669956273077/Womens%20Brand%20Page/W_Brand_Banner.png'
  }
};
const PageFooter = () => {
  const {
    image,
    cta,
    headline,
    description
  } = PAGE_FOOTER;
  const {
    ref,
    EventProvider
  } = useViewEvent({
    schema: 'view',
    name: 'signup_page_promo',
    content_id: 'ungated-categories-footer'
  });
  const {
    reportSelectEvent
  } = useSelectEvent();
  return <EventProvider>
      <Box className={styles.pageFooter} ref={ref}>
        <Box className={styles.textContainer}>
          <ResponsiveSection width="xxlarge">
            <Box className={styles.text}>
              <Box mb={0.5}>
                <Text setting="title-medium">
                  {headline.map(text => <Box key={text}>{text}</Box>)}
                </Text>
              </Box>
              <Text setting="body-medium" mb={1.5}>
                {description}
              </Text>
              <Box>
                <Button as="a" variant="filled-staple" href={cta.destinationPath} onClick={() => reportSelectEvent({
                schema: 'select',
                name: 'signup_page_promo',
                action_name: 'navigate_to_signup'
              })}>
                  {cta.text}
                </Button>
              </Box>
            </Box>
          </ResponsiveSection>
        </Box>
        <Box className={styles.imageContainer} role="presentation">
          <CloudinaryImage alt={image.altText} baseUrl={image.baseUrl} mediaPath={image.mediaPath} sizes={{
          sm: 400,
          md: 900
        }} />
        </Box>
      </Box>
    </EventProvider>;
};
export default PageFooter;